:host {
  display: block;
}

.layout-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: calc(4 * var(--spacer));

  &#integration-types {
    padding-bottom: 25px;
  }
}

gz-integration-type-card {
  width: 400px;
}
